
import React from 'react'
import { MdOutlineDateRange } from "react-icons/md";
import img from "../../assets/business-partners-shaking-hands-agreement 1.png"



const LatestNews = () => {
  return (
    <section className='py-10'>
        <h2 className='text-[#414040] font-semibold text-4xl md:text-[32px] text-center'>Lastest News and Resources</h2>
        <p className='text-[#696984] font-normal text-2xl md:text-[16px] text-center mb-9'>
        read about the latest news and stay up to date with current news 
        </p>
        <section className='flex md:flex-col md:w-[90%] justify-between w-[75%] mx-auto'>
            <div className='w-[50%] md:w-full'>
                <img src={img} alt="" className='h-[250px] w-full rounded-[20px] object-cover' />
                <div className='flex mt-3'>
                    <MdOutlineDateRange color='#5A499C' className='w-[24px] h-[24px]' /> <span className='text-[#696984] text-base font-normal'>29 July, 2022</span>
                </div>
                <h2 className='text-[#252641] font-medium text-2xl mt-3'>260,000 Candidates confirmed for mock test as jamb announces date for main exam.</h2>
                <p className='text-base font-normal text-[#555454] my-4'>No fewer than 260,000 candidates on Thursday sat for this year mock unified Tertiary matriculation examination across 793 CBT centers across Nigeria. Professor Ishaq Oloyede, the Registrar of JAMB, shared this information after observing several centres in Abuja.</p>
                <button className='text-[#5A499C] font-normal text-[22px] md:mb-10' style={{borderBottom: '1px solid #5a499c'}}>Read more</button>
            </div>
            <section className='w-[48%] md:w-full'>
                <div className='flex md:flex-col mb-8'>
                    <div className='bar2 p-1 '>
                        <img src={img} alt="" className='w-[320px] md:w-full rounded-[20px] h-full object-cover' />
                    </div>
                    <div  className='ml-4 md:ml-0'>
                        <h2 className='text-[#252641] font-medium text-[22px] md:mt-4'>260,000 candidates sitting for 2024 Mock UTME, says JAMB.</h2>
                        <p className='text-[#555454] font-normal text-sm mb-4 mt-3'>No fewer than 260,000 candidates on Thursday sat for this year mock unified Tertiary matriculation examination across 793 CBT centers across Nigeria..</p>
                        <button className='text-[#5A499C] font-normal text-[20px]' style={{borderBottom: '1px solid #5a499c'}}>Read more</button>
                    </div>
                </div>
                <div className='flex md:flex-col mb-8'>
                    <div className='bar2 p-1 '>
                        <img src={img} alt="" className='w-[320px]  md:w-full rounded-[20px] h-full object-cover' />
                    </div>
                    <div  className='ml-4 md:ml-0'>
                        <h2 className='text-[#252641] font-medium text-[22px] md:mt-4'>260,000 candidates sitting for 2024 Mock UTME, says JAMB.</h2>
                        <p className='text-[#555454] font-normal text-sm mb-4 mt-3'>No fewer than 260,000 candidates on Thursday sat for this year mock unified Tertiary matriculation examination across 793 CBT centers across Nigeria..</p>
                        <button className='text-[#5A499C] font-normal text-[20px]' style={{borderBottom: '1px solid #5a499c'}}>Read more</button>
                    </div>
                </div>
                <div className='flex md:flex-col mb-8 '>
                    <div className='bar2 p-1 '>
                        <img src={img} alt="" className='w-[320px]   md:w-full rounded-[20px] h-full object-cover' />
                    </div>
                    <div  className='ml-4 md:ml-0'>
                        <h2 className='text-[#252641] font-medium text-[22px] md:mt-4'>260,000 candidates sitting for 2024 Mock UTME, says JAMB.</h2>
                        <p className='text-[#555454] font-normal text-sm mb-4 mt-3'>No fewer than 260,000 candidates on Thursday sat for this year mock unified Tertiary matriculation examination across 793 CBT centers across Nigeria..</p>
                        <button className='text-[#5A499C] font-normal text-[20px]' style={{borderBottom: '1px solid #5a499c'}}>Read more</button>
                    </div>
                </div>
            </section>
        </section>
    </section>
  )
}

export default LatestNews